import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { useAuth } from '@auth/contexts/AuthContext';
import { LoadingSpinner } from '@core/components/LoadingSpinner';
import { ROUTES } from '@core/utils/constants';

interface RouteGuardProps {
  children: React.ReactNode;
  mode: 'protected' | 'public';
}

/**
 * Higher-order component that protects routes.
 * Redirects to login if user is not authenticated and the route is protected.
 * Redirects to dashboard if user is authenticated and the route is public only.
 */
export const RouteGuard = ({ children, mode }: RouteGuardProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }
  if (!user && mode === 'protected') {
    return <Navigate to={ROUTES.auth.login} state={{ from: location }} replace />;
  }
  if (user && mode === 'public') {
    return <Navigate to={location.state?.from?.pathname ?? ROUTES.app.root} replace />;
  }

  return <>{children}</>;
};
